import { Box, styled } from "@mui/material";

export const PdfWrapper = styled(Box)(() => ({
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
}));

export const DocumentWrapper = styled(Box)(() => ({
    overflow: "auto",
    width: "100%",
    height: "100%",
    display: "block",

    // center when smaller, left-align when wider
    "& .react-pdf__Document": {
        width: "max-content",
        marginLeft: "auto",
        marginRight: "auto",
    },

    "& > * > *": {
        paddingBottom: 100,
    },
}));
